import * as React from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';

interface Props {
	className?: string;
}

const Summary: React.FC<Props> = ({ className, children }) => {
	const theme = useTheme('PaymentForm').Summary;

	return <div className={cn(className, theme.container)}>{children}</div>;
};

export default Summary;
